import { useRef, useEffect, useState } from 'react';

interface ProfileCoinProps {
  imageUrl?: string;
  name?: string;
  size?: number;
}

export const ProfileCoin: React.FC<ProfileCoinProps> = ({
  imageUrl = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="200" height="200"%3E%3Crect width="200" height="200" fill="%234a5568"/%3E%3Ctext x="50%25" y="50%25" dominant-baseline="middle" text-anchor="middle" fill="white" font-size="48" font-family="sans-serif"%3E%3F%3C/text%3E%3C/svg%3E',
  name = 'Your Name',
  size = 200,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [rotation, setRotation] = useState({ x: 0, y: 0 });
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleMouseMove = (e: MouseEvent) => {
      if (!isHovered) return;

      const rect = container.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;

      // Calculate rotation based on mouse position relative to center
      const maxRotation = 15; // Maximum rotation in degrees
      const rotateY = ((e.clientX - centerX) / (rect.width / 2)) * maxRotation;
      const rotateX = -((e.clientY - centerY) / (rect.height / 2)) * maxRotation;

      setRotation({ x: rotateX, y: rotateY });
    };

    const handleMouseLeave = () => {
      setIsHovered(false);
      setRotation({ x: 0, y: 0 });
    };

    const handleMouseEnter = () => {
      setIsHovered(true);
    };

    document.addEventListener('mousemove', handleMouseMove);
    container.addEventListener('mouseenter', handleMouseEnter);
    container.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      container.removeEventListener('mouseenter', handleMouseEnter);
      container.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [isHovered]);

  return (
    <div
      ref={containerRef}
      className="profile-coin"
      style={{
        width: `${size}px`,
        height: `${size}px`,
      }}
    >
      <div
        className="profile-coin-inner"
        style={{
          transform: `rotateX(${rotation.x}deg) rotateY(${rotation.y}deg)`,
        }}
      >
        <img
          src={imageUrl}
          alt={name}
          className="profile-coin-img"
        />
        {/* Lighting overlay */}
        <div 
          className="profile-coin-overlay"
          style={{
            background: isHovered
              ? `linear-gradient(${135 + rotation.y}deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 50%, rgba(0,0,0,0.1) 100%)`
              : undefined
          }}
        />
      </div>
    </div>
  );
};
